import { render, staticRenderFns } from "./MiniDatatable.vue?vue&type=template&id=aa98e938"
import script from "./MiniDatatable.vue?vue&type=script&lang=js"
export * from "./MiniDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports